import AccountRoleType from "./AccountRoleType";

class AccountRoleTypeClass {
  constructor(private readonly _value: AccountRoleType = AccountRoleType.NONE) {
  }

  public isCorporation(): boolean {
    return this._value === AccountRoleType.CORPORATION;
  }

  public isStaff(): boolean {
    return this._value === AccountRoleType.STAFF;
  }

  get value(): AccountRoleType {
    return this._value;
  }
}

export default AccountRoleTypeClass;